var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"border rounded-sm border-secondary mb-3"},[_c('div',{staticClass:"item-link typo-body-2 d-flex px-3 py-4 text-decoration-none"},[_c('div',{staticClass:"item-info typo-body-2 color-black-45"},[_vm._v(" "+_vm._s(_vm.skuList)+" ")]),_c('div',{staticClass:"item-actions"},[_c('span',{staticClass:"item-fee"},[_vm._v(_vm._s(_vm.formatFee))]),_c('router-link',{staticClass:"icon-edit",attrs:{"to":{
					name: 'ShippingProductAdditionalFeeEdit',
					params: {
						shippingMethodId: _vm.data.shippingMethodId,
						feeId: _vm.data.id
					}
				}}},[_c('CIcon',{attrs:{"name":"cil-pencil"}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }